export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-New-Post-Attachment-a5c38eb822bbc47d20a34a4d81215667.png";